export enum RefillStatus {
  Pending = 1,
  RequestRefill = 2,
  Stopped = 3,
  Removed = 4,
  RefillNotAllowed = 5,
}
